export enum PaymentMethod {
  CRYPTO = 'crypto',
  CREDIT_CARD = 'credit_card',
  ETH_ON_L2 = 'eth_on_l2'
}
